import React from 'react';
import { OPEN, CLOSE } from 'types/session';
import Request from './Request';

export default function OpenSessions() {
	return <Request status={[OPEN, CLOSE]} mode="open" />;
}
